export const types = function(tools, siteSpecificTypes, language) {

    var cache = {};

    return getType;

    function getType(typeName) {
        if (!typeName) return;
        else if (cache[typeName]) return cache[typeName];
        else if (siteSpecificTypes[typeName]) {
            return makeType(siteSpecificTypes[typeName], typeName);
        }
        else {
            return makeType(require('types/' + typeName), typeName);
        }
    }

    function makeType(type, typeName) {
        if (type?.default) {
            type = type.default
        }

        var dependencies = require('form/typeDependencies').default(tools, language);
        var finishedType = extendType(type(dependencies));
        cache[typeName] = finishedType;
        return finishedType;
    }

    function extendType(type) {
        var extendsType = getType(type.extendsType);
        if (extendsType) {
            type.config = tools.merge(extendsType.config, type.config);
            type.html = type.html || extendsType.html;
        }

        return type;
    }


};
